"use strict";

import { swup, onReady } from './swup.js';
import { addAttributesToOuterLinks, backToTop, anchorScroll } from './common.js';
import { initObservers, destroyObservers } from './observers.js';
import { initCardSwipers } from '../blocks/cards.js';
import { initAniBanner } from '../blocks/anibanner.js';
import { initContactForms } from '../blocks/contact-form.js';
import { initCounters } from '../blocks/counter.js';
import { initHomeVideo, destroyHomeVideo } from '../blocks/home-video.js';
import { ShareButtons } from './globals.js';
import { initLenis, destroyLenis } from './lenis.js';

function applyPageBackgroundColor() {
    const meta = document.querySelector('meta[name="page-background-color"]');
    const color = meta?.getAttribute('content')?.trim();
    if (color) {
        document.body.style.backgroundColor = color;
    } else {
        document.body.style.removeProperty('background-color');
    }
}

function initCore() {
    initLenis();
    addAttributesToOuterLinks();
    backToTop();
    anchorScroll();
    applyPageBackgroundColor();
    initObservers();
    initCardSwipers();
    initAniBanner();
    initContactForms();
    initCounters();
    initHomeVideo();
    ShareButtons?.update?.();
}

// Ready + ogni page:view
onReady(initCore);

swup.hooks.on('content:replace', () => {
    destroyAllScrollPages();
    destroyObservers();
    destroyHomeVideo();
    destroyLenis();
});
